const Entities = state => state.entities;
export default Entities;
